import { Vue } from "@/vue.setup"
import mixins from "@/mixins"
import store from "@/store"
import ProblemCard from "@/components/ProblemCard"
import NormBackend from "@/components/NormBackend"
import NormData from "@/components/NormData"




!!(() => {
    new Vue({
        el: "#app",
		mixins,
		store,
		components: {
			ProblemCard,
			NormBackend,
			NormData,
		},
    });
})();
